import { createContext } from 'react';

import {
  DashboardMode,
  DashboardSummary,
  ReportTab,
} from '@totem/components/services/threats/eventsDashboard/report/types';
import { Params } from '@totem/types/common';

interface Context {
  mode: DashboardMode;
  setMode: (mode: DashboardMode) => void;
  summary: DashboardSummary;
  loading: boolean;
  activeTab: ReportTab;
  setActiveTab: (tab: ReportTab) => void;
  category: string | null;
  showCategory: (category: string) => void;
  clearCategory: () => void;
  buildReportParameters: () => Params;
  reportKey: string;
}

export default createContext<Context>({
  mode: 'open',
  setMode: () => {},
  summary: null,
  loading: true,
  activeTab: 'summary',
  setActiveTab: () => {},
  category: null,
  showCategory: () => {},
  clearCategory: () => {},
  buildReportParameters: () => null,
  reportKey: '',
});
